import { useMemo } from "react";

/**
 * Reads the authenticated tester's Basic Auth username from a meta tag
 * injected by nginx's sub_filter at request time.
 *
 * The React index.html template ships with the literal placeholder
 * `__MINDFORGE_USER__`. nginx rewrites it to $remote_user only AFTER
 * auth_basic has succeeded — so if we ever see the placeholder in the
 * DOM, something is misconfigured (the SPA was served without auth).
 */
export function useUser() {
  const user = useMemo(() => {
    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="x-mindforge-user"]',
    );
    const raw = meta?.content?.trim() ?? "";

    // If nginx didn't substitute, the placeholder leaks through — treat
    // as anonymous so the UI degrades gracefully instead of greeting
    // the user as "__MINDFORGE_USER__".
    if (!raw || raw === "__MINDFORGE_USER__") return "anonymous";

    return raw;
  }, []);

  return { user };
}
